import React, { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';

import { isAppStoreLanding } from '../../api/helpers';
import { useTranslation } from 'react-i18next';
import { Link, SectionHeading, Text } from '../atoms';
import i18n from 'i18n';

const CookieBanner = () => {
  const { t } = useTranslation();

  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // localStorage.removeItem('cookieAccepted'); // For testing purposes, remove this in production
    const accepted = localStorage.getItem('cookieAccepted');
    if (!accepted) setVisible(true);
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieAccepted', 'true');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <Banner>
      <Heading>{i18n.t('bannerHeading')}</Heading>
      <SectionText>
        {t('bannerText')}
        <br />
        <Link
          href={
            isAppStoreLanding
              ? 'https://help.cielomeditation.com/#!/tab/741289809-1'
              : 'https://help.cielomeditation.ru/#!/tab/465761256-3'
          }
          target="_blank">
          {t('privacyPolicy2')}
        </Link>
        {` ${t('and')} `}
        <Link
          href={'https://help.cielomeditation.com/#!/tab/741289809-3'}
          target="_blank">
          {t('cookiePolicy')}
        </Link>
      </SectionText>

      <Button onClick={handleAccept}>{t('gotIt')}</Button>
    </Banner>
  );
};

const Banner = styled.div`
  position: fixed;
  bottom: 40px;
  left: 40px;
  right: 0;
  background-color: #fff;
  max-width: 500px;
  color: white;
  padding: 16px;
  text-align: center;
  z-index: 1000;
  border-radius: 8px;
  flex-direction: column;
  ${(p) => p.theme.max('xs')`
  bottom: 0;
  left: 0;
  `}
`;

const Heading = styled(SectionHeading)`
  font-size: 18px;
  margin-bottom: 10px;
  text-align: left;
`;

const Button = styled.button`
  position: relative;
  border-radius: 100px;
  padding: 15px;
  width: 100px;
  border: 0;
  color: white;
  background-color: #96a8b4;
  font-size: 18px;
  font-family: SF Pro Pro, sans-serif;
  font-weight: 500;
  transition: all 0.3s ease;
  cursor: pointer;
  box-shadow: 5px 5px 11px rgba(0, 0, 0, 0.23);
  ${(p) =>
    p.disabled &&
    css`
      background: rgba(255, 255, 255, 0.05);
      color: rgba(255, 255, 255, 0.2);
    `}
  ${(p) => p.theme.max('md')`
    display: ${(p) =>
      (p.isIos && !p.isApple) || (!p.isIos && p.isApple)
        ? p.isPayment
          ? 'inline'
          : 'none'
        : 'inline'};
  `}
  &:hover {
    background: white;
    color: black;
    ${(p) =>
      p.disabled &&
      css`
        background: rgba(255, 255, 255, 0.05);
        color: rgba(255, 255, 255, 0.2);
      `}
    ${(p) =>
      p.isApple &&
      css`
        > div {
          filter: invert(0%);
        }
      `}
  }
  ${(p) =>
    p.small &&
    css`
      font-size: 16px;
      width: 235px;
      padding: 8px 24px 8px 38px;
      > div {
        width: 18px;
        height: 18px;
      }
    `}
`;

const SectionText = styled(Text)`
  max-width: 520px;
  text-align: left;
  margin: 10px auto;
  font-size: 16px;
  color: ${(p) => (p.white ? 'white' : p.theme.colors.black)};
`;

export default CookieBanner;
